import RoofShapeOther from './../../../../assets/icons/parameters/default/other.svg';
import RoofShapeFlat from './../../../../assets/icons/parameters/recreational/roofShape-flat.svg';
import RoofShapeHalfHip from './../../../../assets/icons/parameters/recreational/roofShape-half-hip.svg';
import RoofShapeHip from './../../../../assets/icons/parameters/recreational/roofShape-hip.svg';
import RoofShapeMansard from './../../../../assets/icons/parameters/recreational/roofShape-mansard.svg';
import RoofShapeMonoPitched from './../../../../assets/icons/parameters/recreational/roofShape-mono-pitched.svg';
import RoofShapePyramid from './../../../../assets/icons/parameters/recreational/roofShape-pyramid.svg';
import RoofShapeSaddleWithDormers from './../../../../assets/icons/parameters/recreational/roofShape-saddle-with-dormers.svg';
import RoofShapeSaddle from './../../../../assets/icons/parameters/recreational/roofShape-saddle.svg';

export default {
    'roofShape-flat': RoofShapeFlat,
    'roofShape-half_hip': RoofShapeHalfHip,
    'roofShape-hip': RoofShapeHip,
    'roofShape-mansard': RoofShapeMansard,
    'roofShape-mono_pitched': RoofShapeMonoPitched,
    'roofShape-other': RoofShapeOther,
    'roofShape-pyramid': RoofShapePyramid,
    'roofShape-saddle': RoofShapeSaddle,
    'roofShape-saddle_with_dormers': RoofShapeSaddleWithDormers,
};
